import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { ResetPasswordForm } from '@/features/authentication/components/reset-password-form'

export const Route = createFileRoute('/reset-password')({
  validateSearch: z.object({
    token: z.string({ message: 'Reset token is required' }),
  }),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: ResetPassword,
})

function ResetPassword() {
  const { token } = Route.useSearch()

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <ResetPasswordForm token={token} />
      </div>
    </div>
  )
}
